import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconQuestion(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M8.693 13.875c-.291 0-.579.068-.839.198L2 17V3.875C2 2.839 2.84 2 3.875 2h12.25C17.16 2 18 2.84 18 3.875V12c0 1.036-.84 1.875-1.875 1.875H8.693ZM16.125 12H8.693a3.75 3.75 0 0 0-1.677.396l-3.141 1.57V3.875h12.25V12Z"
        fill="currentColor"
      />
      <path
        d="M7 16h8.307a3.75 3.75 0 0 1 1.677.396l3.141 1.57V6C21.16 6 22 6.84 22 7.875V21l-5.854-2.927a1.876 1.876 0 0 0-.839-.198H8.875A1.875 1.875 0 0 1 7 16Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
